var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "sidebar-extra-fields" },
    [
      !_vm.settings
        ? _c("div", { staticClass: "sidebar-empty" }, [
            _vm._v(_vm._s(_vm.$ct("sidebar.extra-fields.not-available"))),
          ])
        : _vm.loading
        ? _c(
            "div",
            { staticClass: "sidebar-loading" },
            [_c("w-progress-circular", { attrs: { small: "" } })],
            1
          )
        : _vm.extraFields
        ? _c("app-extra-fields-info", {
            attrs: {
              value: _vm.extraFields,
              "name-settings": _vm.settings.nameSettings,
            },
          })
        : _c("div", { staticClass: "sidebar-empty" }, [
            _vm._v(_vm._s(_vm.$ct("sidebar.extra-fields.not-available"))),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }